import React, { useEffect, Fragment, useState } from 'react';
import { default as initI18n } from './i18n';
import i18next from 'i18next';
import { CountryUtils, Constants } from '@card/commonlib';
import { useCountry, Country } from '@increasecard/increase-core';

/**
 * Initializes the translations service, making it load current's user
 * language before rendering any other component.
 *
 * @param children the elements whose render will be blocked during translations retrieval.
 */
export default function I18nLoader({
  children
}: {
  children: React.ReactElement[] | React.ReactElement;
}) {
  const country = useCountry() as Country;
  const [api, setAPI] = useState<typeof i18next | null>(null);
  useEffect(() => {
    initI18n({
      langCode: CountryUtils.countryToLangCode(country || Constants.Countries.ARGENTINA)
    }).then((i18nextAPI: typeof i18next) => {
      setAPI(i18nextAPI);
    });
    return () => setAPI(null);
  }, [country]);

  return api ? <Fragment>{children}</Fragment> : null;
}
